module.exports = __webpack_public_path__ + "img/footer-logo.8dab4cb5.png";